const mq = window.matchMedia('(min-width: 992px)');

// Function to calculate distance between 2 points
google.maps.LatLng.prototype.distanceFrom = function (p2) {
  const R = 6378137; // earth's mean radius in meters (this was a parameter in V2)
  const rad = function (x) {
    return (x * Math.PI) / 180;
  };
  const dLat = rad(p2.lat() - this.lat());
  const dLong = rad(p2.lng() - this.lng());

  const a = (Math.sin(dLat / 2) * Math.sin(dLat / 2))
        + (Math.cos(rad(this.lat())) * Math.cos(rad(p2.lat()))
            * Math.sin(dLong / 2) * Math.sin(dLong / 2));
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;

  return d.toFixed(3);
};

Vue.component('shoplist', {
  data() {
    return {
      mapId: 'shop-map',
      shopLocations: jsonShops,
      zipCode : jsonZipCode,
      markers: [],
      infoWindows: [],
      map: null,
      bounds: null,
      geocoder: null,
      markerIconUrl: `/Content/icons/${website.concept}/marker.svg`,
      markerIcon2Url: `/Content/icons/${website.concept}/marker2.svg`,
      markerIconInActiveUrl: `/Content/icons/${website.concept}/marker-inactive.svg`,
      markerIconActiveUrl: `/Content/icons/${website.concept}/marker-active.svg`,
      mapLoaded: false,
      isMobile: !mq.matches,
      states: {
        mapMode: false,
        filterMode: false,
      },
      currentLocation: null,
      searchInput: '',
      searchLatResult: null,
      searchLngResult: null,
      searchLatLng: null,
      noSearchResults: false,
      filterLoadIndex: 1,
      firstTimeLoad: true,
      premiumStoresFilter: false
    };
  },
  mounted() {

    if (window.location.href.includes("?premiumstores=true")) {
        this.premiumStoresFilter = true;
    }

    this.geocoder = new google.maps.Geocoder();
    this.createMap();
      mq.addListener(this.handleViewportChange);

      if (this.zipCode !== '') {
          this.searchInput = unescape(this.zipCode);
          Vue.nextTick(() => {
              this.geocodeAddress();
          });
      }
  },
  computed: {
    totalShopAmount() {
      return this.shopLocations.length;
    },
    shopsFilteredByDistance() {
      let shopsFilteredByDistance = [];
      shopsFilteredByDistance = this.shopLocations.sort((a, b) => a.distance - b.distance);

      const itemsToLoad = this.firstTimeLoad ? 10 : 25;

      return shopsFilteredByDistance.slice(0, this.filterLoadIndex * itemsToLoad);
    },
  },
  methods: {
    createMap() {
      if (!this.mapLoaded) {
        const mapElement = document.getElementById(this.mapId);
        const mapCenter = this.shopLocations[0];
        const options = {
          center: new google.maps.LatLng(mapCenter.latitude, mapCenter.longitude),
          mapTypeControl: false,
          fullscreenControl: false,
          maxZoom: 13,
          styles: [{
            featureType: 'administrative.country',
            elementType: 'geometry.fill',
            stylers: [{
              visibility: 'on',
            }],
          },
          {
            featureType: 'administrative.country',
            elementType: 'geometry.stroke',
            stylers: [{
                color: '#ff2900',
            },
            {
              visibility: 'on',
            },
            {
              weight: 1,
            },
            ],
          },
          {
            featureType: 'administrative.province',
            elementType: 'geometry.stroke',
            stylers: [{
              color: '#7f817d',
            },
            {
              weight: 1,
            },
            ],
          },
          ],
        };

        this.bounds = new google.maps.LatLngBounds();
        this.map = new google.maps.Map(mapElement, options);
        this.mapLoaded = true;

        this.shopLocations.forEach(shop => this.placeMarkers(shop));
        this.map.fitBounds(this.bounds);
      }
    },
    placeMarkers(shop) {
      if (shop.latitude && shop.longitude) {
        const position = new google.maps.LatLng(shop.latitude, shop.longitude);
        const marker = new google.maps.Marker({
          position,
          map: this.map,
          animation: google.maps.Animation.DROP,
          optimized: false,
          icon: {
              url: shop.active ? (shop.premiumDealer ? this.markerIconUrl : this.markerIcon2Url) : this.markerIconInActiveUrl,
            size: new google.maps.Size(41, 44),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, 44),
            scaledSize: new google.maps.Size(41, 44),
          },
        });

        const infoWindow = this.createInfoWindow(shop);
        this.infoWindows.push(infoWindow);

        google.maps.event.addListener(marker, 'click', () => this.setActiveMarker(marker, infoWindow));
        this.bounds.extend(position);
        this.markers.push(marker);
      }
    },
    setActiveMarker(marker, infoWindow) {
      // First clear all active markers (if any)
      // and close InfoWindows

      // this.clearActiveMarkers();
      this.closeAllInfoWindows();

      // Set marker to active
      // marker.setIcon(this.markerIconActiveUrl);

      // Open InfoWinfow
      infoWindow.open(this.map, marker);

      this.map.panTo(marker.position);
    },
    clearActiveMarkers() {
      this.markers.forEach((marker) => {
        marker.setIcon(this.markerIconUrl);
      });
    },
    createInfoWindow(shop) {
      const openingHoursList = document.createElement('dl');
      openingHoursList.classList.add('infoBox__list');

      if (shop.openingsHours) {
        shop.openingsHours.forEach((o) => {
          const dt = document.createElement('dt');
          const dd = document.createElement('dd');

          dt.appendChild(document.createTextNode(o.day));
          dd.appendChild(document.createTextNode(o.time ? o.time : ''));

          openingHoursList.appendChild(dt);
          openingHoursList.appendChild(dd);
        });
      }

      const grandOpeningDate = document.createElement('p');
      grandOpeningDate.classList.add('infoBox__text');

      if (!shop.active) {
        const shopOpeningDate = new Date(shop.grandOpeningDate);
        const shopOpeningMessage = messages.messageGrandOpeningShop.replace(
          '{GrandOpeningDate}',
          shopOpeningDate.toLocaleDateString(document.documentElement.lang, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }),
        );

        grandOpeningDate.innerHTML = shopOpeningMessage;

        // Add 'openingMessage' to Shop Vue Object to be used in View
        this.$set(shop, 'openingMessage', shopOpeningMessage);
      }

      var dealerType = "";
        if (shop.dealerType !== "") {
          dealerType = `<div class="infoBox__header__dealertype">${shop.dealerType}</div>`;
      }

      return new InfoBox({
          content: `<div class="infoBox__header">
                            <div class ="infoBox__header__titleblock">
                                ${dealerType}
                                <div class="infoBox__header__title">${shop.name}</div>
                            </div>
                            <button class="infoBox__close" onclick="app.$refs.shoplist.closeAllInfoWindows();">
                                <svg class="infoBox__close__icon icon"><use xlink:href="#close"></use></svg>
                            </button>
                            <img src="${shop.image}" class="infoBox__image" alt="${shop.name}" width="304">
                        </div>
                        <div class="infoBox__body">
                            ${(!shop.active ? grandOpeningDate.outerHTML : openingHoursList.outerHTML)}
                            <div class="infoBox__body__cta">
                                <a href="${shop.internalUrl}" class="button button--secondary button--border button--small">${shop.buttonText}</a>
                            </div>
                        </div>`,
        disableAutoPan: false,
        maxWidth: 0,
        alignBottom: true,
        pixelOffset: new google.maps.Size(-152, -50),
        zIndex: null,
        boxStyle: {},
        closeBoxURL: '',
        infoBoxClearance: new google.maps.Size(1, 1),
        isHidden: false,
        pane: 'floatPane',
        enableEventPropagation: false,
      });
    },
    closeAllInfoWindows() {
      this.infoWindows.forEach(infoWindow => infoWindow.close());
    },
    toggleMapState() {
      this.states.mapMode = !this.states.mapMode;

      Vue.nextTick(() => {
        if (this.states.mapMode) {
          if (this.searchLatLng !== null) {
            this.map.setCenter(this.searchLatLng);
            this.map.setZoom(10);
          } else {
            this.map.fitBounds(this.bounds);
          }
        } else {
          fAccordion();
        }
      });
    },
    handleViewportChange() {
      if (mq.matches) {
        this.isMobile = false;
        this.states.mapMode = false;
      } else {
        this.isMobile = true;
      }
    },
    checkPremiumStores() {
        var hr = window.location.href.split('?')[0];

        if (this.premiumStoresFilter) {
            window.location.href = hr + "?premiumstores=true";
        } else {
            window.location.href = hr;
        }
    },
    geocodeAddress() {
        const address = `${this.searchInput}, ${app.country}`;

      if (!this.firstTimeLoad) {
        this.firstTimeLoad = true;
        this.filterLoadIndex = 1;
      }

      this.geocoder.geocode({
        address,
      }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          this.noSearchResults = false;
          this.searchLatResult = results[0].geometry.location.lat();
          this.searchLngResult = results[0].geometry.location.lng();
          this.searchLatLng = new google.maps.LatLng(this.searchLatResult, this.searchLngResult);

          this.setShopDistance(this.searchLatLng);

          app.influxDbEvent("ShopSearch");

        } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
          this.states.filterMode = true;
          this.noSearchResults = true;
        } else {
          // error
        }
      });
    },
    calculateDistance(gLatLng1, gLatLng2) {
      return Math.round(gLatLng1.distanceFrom(gLatLng2) / 1000);
    },
    setShopDistance(fromLocation) {
      this.shopLocations.forEach((shop) => {
        const shopLatLng = new google.maps.LatLng(shop.latitude, shop.longitude);
        app.$refs.shoplist.$set(shop, 'distance', this.calculateDistance(fromLocation, shopLatLng));
      });

      this.map.setCenter(fromLocation);
      this.map.setZoom(10);

      this.states.filterMode = true;
    },
    focusProvince(e, province) {
      province = province.replace("&quot;", "'");
      if (e.target.parentElement.dataset.accordionActive !== 'true') {
          const shopsPerProvice = this.shopLocations.filter(s => s.province === province);

        this.bounds = new google.maps.LatLngBounds();

        shopsPerProvice.forEach((s) => {
          const position = new google.maps.LatLng(s.latitude, s.longitude);
          this.bounds.extend(position);
        });

        this.map.fitBounds(this.bounds);
        this.map.panToBounds(this.bounds);
      }
    },
    getCurrentPositionSuccess(position) {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      this.currentLocation = new google.maps.LatLng(lat, lng);

      this.setShopDistance(this.currentLocation);
    },
    getCurrentPositionError() {
      // console.log('Fout bij ophalen locatie');
    },
    getCurrentLocation() {
      if (!navigator.geolocation) {
        return;
      }

      navigator.geolocation.getCurrentPosition(
        this.getCurrentPositionSuccess,
        this.getCurrentPositionError,
      );
    },
    loadMoreFilteredShops() {
      if (this.firstTimeLoad) {
        this.firstTimeLoad = false;
      } else {
        this.filterLoadIndex += 1;
      }
    },
    resetFilterMode() {
      this.states.filterMode = !this.states.filterMode;
      this.searchInput = '';
      this.searchLatLng = null;

      setTimeout(() => {
        fAccordion();
      }, 0);
    },
  },
});
